import React from 'react';

const DenyPage = React.lazy(() => import('./DenyPage' /* webpackChunkName: "Deny" */));
const DenyPageInitializer = () => <DenyPage />;
export default DenyPageInitializer;
